/** "View as" (administrator / operations supervisor): the person whose view is shown, kept for this tab only. */
const KEY = 'ea:viewAs';

export function getViewAs(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** Switches the whole app to another person's view (read-only) and reloads it from their home page. */
export function startViewAs(target: string) {
  try {
    sessionStorage.setItem(KEY, target);
  } catch {
    /* storage unavailable: nothing to do */
  }
  window.location.assign('/');
}

export function exitViewAs() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  window.location.assign('/');
}
